import { router } from '@inertiajs/vue3';

export function useProtocoloNavigation() {
    const getConsultaProtocoloRoute = () => route('consulta-protocolo');
    const getMeusProtocolosRoute = () => route('meus-protocolos');
    const getSolicitacoesAssinaturaRoute = () => route('meus-protocolos.solicitacoes-assinatura');
    const getListarProcessosRoute = (tipoProcessoCodigo, descricao) => route('meus-protocolos.listar', { tipoProcessoCodigo, descricao });

    const goToConsultaProtocolo = () => router.visit(getConsultaProtocoloRoute());
    const goToMeusProtocolos = () => router.visit(getMeusProtocolosRoute());
    const goToSolicitacoesAssinatura = () => router.visit(getSolicitacoesAssinaturaRoute());
    const goToListarProcessos = (tipoProcessoCodigo, descricao) => router.visit(getListarProcessosRoute(tipoProcessoCodigo, descricao));

    return {
        getConsultaProtocoloRoute, getMeusProtocolosRoute,
        getSolicitacoesAssinaturaRoute, getListarProcessosRoute,
        goToConsultaProtocolo, goToMeusProtocolos,
        goToSolicitacoesAssinatura, goToListarProcessos
    };
}
